"use client";

import { useEffect, useState } from "react";
import { useAutumnContext } from "../AutumnContext";
import { getOrCreateCustomer, getCustomer } from "../../server/cusActions";
const defaultOptions = {
  autoCreate: true
};
const useCustomer = (options) => {
  let finalOptions = defaultOptions;
  if (options) {
    finalOptions = { ...defaultOptions, ...options };
  }
  const { autoCreate } = finalOptions;
  const { encryptedCustomerId, customerData, customer, setCustomer } = useAutumnContext();
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const fetchCustomer = async () => {
    setIsLoading(true);
    let returnData = null;
    try {
      let data = null;
      let error2 = null;
      if (autoCreate) {
        const result = await getOrCreateCustomer({
          encryptedCustomerId,
          customerData
        });
        data = result.data;
        error2 = result.error;
      } else {
        const result = await getCustomer({ encryptedCustomerId });
        data = result.data;
        error2 = result.error;
      }
      if (error2) {
        console.log("(Autumn) Error fetching customer:", error2);
        setError(error2);
      } else {
        setCustomer(data);
      }
      returnData = data;
    } catch (error2) {
      console.error("(Autumn) Error fetching customer:", error2);
      setError(error2);
    }
    setIsLoading(false);
    return returnData;
  };
  const refetch = async () => {
    await fetchCustomer();
  };
  useEffect(() => {
    fetchCustomer();
  }, [encryptedCustomerId]);
  return { customer, isLoading, error, refetch };
};
export {
  useCustomer
};
